var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlagiarismTotalWords(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 50,
    viewBox: "0 0 37 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2132_3420)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.66016 3.65918H33.3008V43.4111H36.9997V0H6.66016V3.65918Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.99609 36.458L13.6901 44.0693V36.458H5.99609Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 6.58887V28.4043C0 31.2295 2.32379 33.5283 5.17966 33.5283H16.6505V44.876C16.6505 47.7012 18.9743 50 21.8302 50H30.3396V6.58887H0ZM24.1876 13.3975C24.1876 13.9619 23.7246 14.4189 23.155 14.4189C22.5854 14.4189 22.1224 13.9619 22.1224 13.3975V11.3545H10.9023L17.2359 18.8721C17.5548 19.251 17.5548 19.8018 17.2359 20.1807L10.9023 27.6992H22.1224V25.6562C22.1224 25.0918 22.5854 24.6348 23.155 24.6348C23.7246 24.6348 24.1876 25.0918 24.1876 25.6562V28.7207C24.1876 29.2852 23.7246 29.7422 23.155 29.7422H8.69793C8.29714 29.7422 7.93287 29.5127 7.76209 29.1533C7.59131 28.7939 7.64758 28.3711 7.90424 28.0664L15.0977 19.5264L7.90424 10.9873C7.64758 10.6816 7.5923 10.2578 7.76209 9.89941C7.93287 9.54102 8.29714 9.31055 8.69793 9.31055H23.155C23.7256 9.31055 24.1876 9.76758 24.1876 10.332V13.3965V13.3975Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2132_3420"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 37,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlagiarismTotalWords);
export default __webpack_public_path__ + "static/media/plagiarism_total_words.912c1fa02ed8317ba24af4e8a44d4ac1.svg";
export { ForwardRef as ReactComponent };